import { Component } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-run-status',
  templateUrl: './run-status.component.html',
  styleUrl: './run-status.component.scss'
})
export class RunStatusComponent {
  tabChangeEvent: string = 'Sample Errors';

  selectedTabChangeHandler($event: MatTabChangeEvent) {
    this.tabChangeEvent = $event.tab.textLabel;
  }
}
